"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _merge = _interopRequireDefault(require("lodash/merge"));

var _styledComponents = require("styled-components");

var _isEqual = _interopRequireDefault(require("lodash/isEqual"));

var _theme = _interopRequireWildcard(require("../../styles/theme"));

var _propTypes2 = _interopRequireDefault(require("../../constants/propTypes"));

var _cssReset = require("../../styles/0_rootStyleAttributes/cssReset");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ComponentLibThemeProvider = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(ComponentLibThemeProvider, _React$PureComponent);

  var _super = _createSuper(ComponentLibThemeProvider);

  _createClass(ComponentLibThemeProvider, null, [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      if (!(0, _isEqual.default)(props.theme, state.prevThemeProps)) {
        return {
          theme: (0, _merge.default)((0, _theme.toTheme)(_theme.default), props.theme),
          prevThemeProps: (0, _merge.default)({}, props.theme),
          key: state.key + 1
        };
      }

      return null;
    }
  }]);

  function ComponentLibThemeProvider(props) {
    var _this;

    _classCallCheck(this, ComponentLibThemeProvider);

    _this = _super.call(this, props);
    _this.state = {
      theme: (0, _merge.default)((0, _theme.toTheme)(_theme.default), props.theme),
      prevThemeProps: {},
      key: 1
    };
    return _this;
  }

  _createClass(ComponentLibThemeProvider, [{
    key: "render",
    value: function render() {
      var children = this.props.children;
      var _this$state = this.state,
          theme = _this$state.theme,
          key = _this$state.key; // todo: please note that this may be a little heavy handed - we set a global style reset

      return /*#__PURE__*/_react.default.createElement(_styledComponents.ThemeProvider, {
        theme: theme,
        key: key
      }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_cssReset.CssReset, null), children));
    }
  }]);

  return ComponentLibThemeProvider;
}(_react.default.PureComponent);

_defineProperty(ComponentLibThemeProvider, "propTypes", {
  children: _propTypes2.default.children,
  theme: _propTypes.default.object // eslint-disable-line react/forbid-prop-types

});

_defineProperty(ComponentLibThemeProvider, "defaultProps", {
  children: '',
  theme: {}
});

var _default = ComponentLibThemeProvider;
exports.default = _default;